import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoDark from "../../asset/logo_dark.png";
import logoWeiß from "../../asset/logo_weiß.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser, faEuroSign, faInfoCircle, faPerson, faUser } from '@fortawesome/free-solid-svg-icons';
import '../LandingPage.css';

import './Navbar.css';

const translations = {
    english: {
      language: 'Language',
      confessDataToolMenu: 'Confess-data-tool-Menu',
      home: 'Home',
      dashboard: 'Dashboard',
      dataPolicy: 'Data Policy',
      imprint: 'Imprint',
      logout: 'Logout',
      settings: "Edit Profile",
      editPassword: "Edit Password",      
    },
    german: {
      language: 'Sprache',
      confessDataToolMenu: 'Confess-Daten-Tool-Menü',
      home: 'Startseite',
      dashboard: 'Dashboard',
      dataPolicy: 'Datenschutzerklärung',
      imprint: 'Impressum',
      logout: 'Abmelden',
      settings: "Profil bearbeiten",
      editPassword: "Passwort ändern",
    },
    czech: {
      language: 'Jazyk',
      confessDataToolMenu: 'Konfesní datové nástroje - Menu',
      home: 'Domů',
      dashboard: 'Dashboard',
      dataPolicy: 'Zásady ochrany osobních údajů',
      imprint: 'Otisk',
      logout: 'Odhlásit se',
      settings: "Settings",
      editPassword: "Edit Password",  
    },
    italian: {
      language: 'Lingua',
      confessDataToolMenu: 'Confess-data-tool-Menu',
      home: 'Home',
      dashboard: 'Dashboard',
      dataPolicy: 'Informativa sulla privacy',
      imprint: 'Note legali',
      logout: 'Esci',
      settings: "Modifica profilo",
      editPassword: "Modifica password",  
    },
  };

const LanguageSelector = ({ translations, changeLanguage, currentLanguage }) => {
    return (
        <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {translations[currentLanguage].language}
            </a>
            <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="#" onClick={() => changeLanguage('english')}>English</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => changeLanguage('german')}>Deutsch</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => changeLanguage('czech')}>Česky</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => changeLanguage('italian')}>Italiano</a></li>
            </ul>
        </li>
    );
  };

const UserLinks = () => (
    <>
        <li className="nav-item">
            <a className="nav-link" href="/assessment">Assessments</a>
        </li>
        <li className="nav-item">
            <a className="nav-link" href="/results">Reports</a>
        </li>
        <li className="nav-item">
            <a className="nav-link" href="/users">Users</a>
        </li>
        <li className="nav-item">
            <a className="nav-link" href="/users/review">Reviews</a>
        </li>
    </>
);

const NavSection = () => {
    const navigate = useNavigate();
    const [currentUser, setCurrentUser] = useState(null);
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
    const [loading, setLoading] = useState(true); // Add loading state
    const config=require( '../../config.js');

    const [username, setUsername] = useState('');

    useEffect(() => {
        setLoading(true);
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        if (user) {
            setCurrentUser({ ...user, role: user.role === 'users' ? 'user' : user.role});
            setUsername(user.name);
            setLoading(false);
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('email');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/');
    };

    const changeLanguage = (language) => {
        if (currentLanguage !== language) {
            localStorage.setItem('language', language);
            setCurrentLanguage(language);
            window.location.reload(); // Force reload to apply language changes
        }
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-dark">
                <div className="container">
                    <a className="navbar-brand" href={currentUser?.role === 'users' ? "/landing" : "#"}>
                        <img src={logoWeiß} alt='logo' width={200} />
                    </a>
                    <button className="navbar-toggler btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    {/* Toggle menu */}
                    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasNavbarLabel">{translations[currentLanguage].confessDataToolMenu}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                                { currentUser?.role === 'users' && 
                                <li className="nav-item">
                                    <a className="dropdown-item" aria-current="page" href="/landing">{translations[currentLanguage].home}</a>
                                </li>
                                }
                                <li className="nav-item">
                                    <a className="dropdown-item" href="/reports">{translations[currentLanguage].dashboard}</a>
                                </li>
                                {!loading && currentUser?.role === 'admin' && <UserLinks />} {/* Show UserLinks only after loading */}
                                <LanguageSelector translations={translations} changeLanguage={changeLanguage} currentLanguage={currentLanguage} />
                                <li className="nav-item">
                                    <a className="nav-link" href="/datapolicy">{translations[currentLanguage].dataPolicy}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/imprint">{translations[currentLanguage].imprint}</a>
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {`${username}`} </a>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <a className="dropdown-item" href="/profile">Settings</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="dropdown-item logout-btn" onClick={handleLogout}>{translations[currentLanguage].logout}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* Normal menu */}
                    <div className="d-none d-lg-block">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {!loading && currentUser?.role === 'user' && 
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/landing">{translations[currentLanguage].home}</a>
                            </li> }
                            {!loading && currentUser?.role === 'admin' && <UserLinks />} {/* Show UserLinks only after loading */}
                            {!loading && currentUser?.role === 'user' &&
                            <>
                            <li className="nav-item">
                                <a className="nav-link" href="/assessment/user">Assessments</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/reports">{translations[currentLanguage].dashboard}</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/reports/view">Reports</a>
                            </li>
                            </>
                            }
                            {!loading && currentUser?.role === 'expert' &&
                            <>
                            <li className="nav-item">
                                <a className="nav-link" href="/reports/expert/view">Reports</a>
                            </li>
                            </>
                            }
                            {!loading && currentUser?.role === 'third' &&
                            <>
                            <li className="nav-item">
                                <a className="nav-link" href="/reports/third/view">Reports</a>
                            </li>
                            </>
                            }
                            <LanguageSelector translations={translations} changeLanguage={changeLanguage} currentLanguage={currentLanguage} />
                            
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {`${username}`} </a>
                                <ul className="dropdown-menu">
                                    <li className="nav-item">
                                        <a className="dropdown-item" href="/profile">{translations[currentLanguage].settings}</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="dropdown-item" href="/edit-password">{translations[currentLanguage].editPassword}</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="dropdown-item logout-btn" onClick={handleLogout}>{translations[currentLanguage].logout}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div >
            </nav >
        </>
    );
};

export default NavSection;
